import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs";
import { auditTime, distinctUntilChanged, first } from "rxjs/operators";
import * as fromApp from "../../../store/app.reducer";
import * as _ from "lodash";

import * as selectors from "./../../../store/app.selectors";
import { isMobileOrderCartCustomOptionVisible } from "../cart-custom-options/cart-custom-options.helpers";

@Component({
  selector: "app-extra-choices",
  templateUrl: "./extra-choices.component.html",
  styleUrls: ["./extra-choices.component.scss"],
})
export class ExtraChoicesComponent implements OnInit, OnDestroy {
  public store_info: any;
  public cart: any;
  public cartCustomerOptions: any;
  public cartOptionsShown: any;
  public atLeastOneOptionToShow = false;
  public preorderActive: boolean = false;

  private selectedPreorderDate;
  private currentUser: any;
  private orderPickup: any;
  private dineIn: any;
  private selectedPaymentMethodID: any;
  private subscriptions: Subscription[] = [];

  constructor(private store: Store<fromApp.AppState>) {}

  ngOnInit() {
    this.subscriptions.push(
      this.store
        .select("auth")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (state && !_.isEqual(this.currentUser, state.user)) {
            this.currentUser = _.cloneDeep(state.user);
            if (this.store_info) {
              this.checkIfCartOptionsShownDebounced();
            }
          }
        })
    );
    this.subscriptions.push(
      this.store
        .select("cartCustomerOptions")
        .pipe(distinctUntilChanged())

        .subscribe((state) => {
          if (
            state &&
            state.cartCustomerOptions &&
            !_.isEqual(this.cartCustomerOptions, state.cartCustomerOptions)
          ) {
            this.cartCustomerOptions = _.cloneDeep(state.cartCustomerOptions);
            this.checkIfCartOptionsShownDebounced();
          }
        })
    );
    this.subscriptions.push(
      this.store
        .select("cart")
        .pipe(distinctUntilChanged())

        .subscribe((state) => {
          if (
            state &&
            state.products &&
            !_.isEqual(this.cart, state.products)
          ) {
            this.cart = _.cloneDeep(state.products);
            if (this.selectedPaymentMethodID && this.store_info && this.cart) {
              this.checkIfCartOptionsShownDebounced();
            }
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("deliveryMethodAddress")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (state && !_.isEqual(this.orderPickup, state.orderPickup)) {
            this.orderPickup = _.cloneDeep(state.orderPickup);
            if (this.selectedPaymentMethodID && this.store_info && this.cart) {
              this.checkIfCartOptionsShownDebounced();
            }
          }

          if (state && !_.isEqual(this.dineIn, state.dineIn)) {
            this.dineIn = _.cloneDeep(state.dineIn);
            if (this.selectedPaymentMethodID && this.store_info && this.cart) {
              this.checkIfCartOptionsShownDebounced();
            }
          }

          if (
            state &&
            !_.isEqual(this.selectedPreorderDate, state.selectedPreorderDate)
          ) {
            this.selectedPreorderDate = _.cloneDeep(state.selectedPreorderDate);
            this.preorderActive = false;
            if (
              this.selectedPreorderDate &&
              this.selectedPreorderDate.date &&
              this.selectedPreorderDate.hour
            ) {
              this.preorderActive = true;
            }

            this.checkIfCartOptionsShownDebounced();
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select(selectors.getStoreInfo)
        .pipe(distinctUntilChanged())

        .subscribe((storeInfo) => {
          if (storeInfo && !_.isEqual(storeInfo, this.store_info)) {
            this.store_info = _.cloneDeep(storeInfo);
            if (this.selectedPaymentMethodID && this.store_info && this.cart) {
              this.checkIfCartOptionsShownDebounced();
            }
            console.log("store Info from cart options", this.store_info);
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("selectedPaymentMethodID")
        .pipe(distinctUntilChanged())

        .subscribe((state) => {
          if (
            state &&
            !_.isEqual(
              state.selectedPaymentMethodID,
              this.selectedPaymentMethodID
            )
          ) {
            this.selectedPaymentMethodID = _.cloneDeep(
              state.selectedPaymentMethodID
            );
            if (this.selectedPaymentMethodID && this.store_info && this.cart) {
              this.checkIfCartOptionsShownDebounced();
            }
          }
        })
    );
  }

  private checkIfCartOptionsShownDebounced = _.debounce(() => {
    this.checkIfCartOptionsShown();
  }, 100);

  checkIfCartOptionsShown() {
    this.cartOptionsShown = null;
    this.atLeastOneOptionToShow = false;
    // console.log(
    //   "check if cart options is shown",
    //   this.store_info,
    //   this.selectedPaymentMethodID,
    //   this.orderPickup,
    //   this.cart,
    //   this.cartCustomerOptions
    // );

    let shownOptionsCounter = 0;
    let showOptionChoicesCounter = 0;
    _.each(this.cartCustomerOptions, (option) => {
      if (option && option.type && option.type === "plasticTax") {
        _.each(option.choices, (choice, index: any) => {
          console.log("choices of plastic tax", choice);
          if (
            choice.qty > 0 &&
            choice.totalPrice &&
            choice.totalPrice !== "0.00"
          ) {
            this.atLeastOneOptionToShow = true;
            this.cartOptionsShown = "show";
            if (index === 0) {
              shownOptionsCounter = shownOptionsCounter + 1;
              showOptionChoicesCounter =
                showOptionChoicesCounter + option.choices.length;
            }
          }
        });
      }
    });

    _.each(this.store_info.cartCustomOptions, (option) => {
      if (
        this.store_info.cartCustomOptionsActive &&
        this.cart &&
        this.cart.length > 0 &&
        isMobileOrderCartCustomOptionVisible(option, this.currentUser) &&
        option &&
        option.type !== "plasticTax" &&
        ((!option.pickupOnly && !option.deliveryOnly && !option.dineinOnly) ||
          (option.pickupOnly && this.orderPickup) ||
          (option.deliveryOnly && !this.orderPickup && !this.dineIn) ||
          (option.dineinOnly && this.dineIn)) &&
        (!this.dineIn || (this.dineIn && option.showInDinein)) &&
        (!option.onlinePaymentOnly ||
          !this.isOfflinePaymentMethod(this.selectedPaymentMethodID)) &&
        (!option.disabledOnPreorder || !this.preorderActive)
      ) {
        this.cartOptionsShown = "show";
        shownOptionsCounter = shownOptionsCounter + 1;
        showOptionChoicesCounter =
          showOptionChoicesCounter + option.choices.length;
        this.atLeastOneOptionToShow = true;
      }
    });

    if (
      this.cartOptionsShown === "show" &&
      shownOptionsCounter === 1 &&
      showOptionChoicesCounter === 1
    ) {
      this.cartOptionsShown = "notShow";
    }

    if (!this.cartOptionsShown) {
      this.cartOptionsShown = "notShow";
    }
  }

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }

  private isOfflinePaymentMethod(paymentMethodId: string) {
    return (
      paymentMethodId === "cash" ||
      paymentMethodId === "mobilePOS" ||
      paymentMethodId === "pre_cash" ||
      paymentMethodId === "pre_mobilePOS"
    );
  }
}
